import { memo as Memo, useMemo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import Page from 'components/common/Page'
import MapboxMap from 'components/pages/map'

const Map = Memo(({ pages, pageParams, selectedLang }) => {

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    return (
        <Page
            meta={pageData?.content?.meta}
            className='Map'
            nextSeoProps={{
                noindex: true,
                nofollow: true
            }}
            hrefLang={false}
            transparentHeader={pageParams.transparentHeader && !pageData}
        >
            {pageData && <MapboxMap {...pageData} />}
        </Page>
    )
})

export default withDataContext(Map, ['pages'])
